<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-bell</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list dark style="background-color: #00479b">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>ตั้งค่าการแจ้งเตือน</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-item two-line>
            <v-list-item-action>
              <v-switch v-model="noti.isLine" color="success"></v-switch>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Line</v-list-item-title>
              <v-list-item-subtitle>
                Login Line Account เพื่อเชื่อมกับ CMU Account
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar rounded="0" v-if="$vuetify.breakpoint.smAndUp">
              <v-img src="../../assets/image/LINE_SOCIAL_Basic.png"></v-img>
            </v-list-item-avatar>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-action>
              <v-switch v-model="noti.isEmail" color="success"></v-switch>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>E-mail</v-list-item-title>
              <v-list-item-subtitle>CMU Account</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar rounded="0" v-if="$vuetify.breakpoint.smAndUp">
              <v-icon x-large color="blue">mdi-email</v-icon>
            </v-list-item-avatar>
          </v-list-item>

          <!-- <v-list-item>
            <v-list-item-action>
              <v-switch
                v-model="noti.isCMUMobile"
                disabled
                color="success"
              ></v-switch>
            </v-list-item-action>
            <v-list-item-title>CMU Mobile</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-action>
              <v-switch
                v-model="noti.isPWA"
                disabled
                color="success"
              ></v-switch>
            </v-list-item-action>
            <v-list-item-title>PWA</v-list-item-title>
          </v-list-item> -->
        </v-list>

        <v-card-actions>
          <v-btn
            color="primary"
            :loading="app_list_loading"
            text
            @click="openDialog"
          >
            ระบบที่รองรับการแจ้งเตือน
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" text @click="menu = false">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    <v-dialog v-model="app_list_dialog" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">
          ระบบที่รองรับการแจ้งเตือน
        </v-card-title>
        <v-card-text>
          <span
            v-for="(text, i) in app_list"
            :key="'applist' + i"
            style="font-size: 16px"
            >- {{ text }}
            <br />
          </span>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" text @click="closeDialog">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      app_list: [],
      app_list_loading: false,
      app_list_dialog: false,
      menu: false,
      noti: {
        isLine: false,
        isEmail: false,
        isCMUMobile: false,
        isPWA: false
      },
      loading: true
    }
  },

  watch: {
    line: {
      async handler() {
        if (!this.loading) {
          try {
            const res = await this.apiPostSelfNoti({
              isLine: this.line
            })
            if (res) {
              window.location = res
            }
          } catch (e) {
            console.log(e)
          }
        } else {
          this.loading = false
        }
      }
    },
    email: {
      async handler() {
        await this.apiPostSelfNoti({
          isEmail: this.email
        })
      }
    }
  },

  computed: {
    line() {
      return this.noti.isLine
    },
    email() {
      return this.noti.isEmail
    },
    cmu_mobile() {
      return this.noti.isCMUMobile
    },
    pwa() {
      return this.noti.isPWA
    }
  },

  async mounted() {
    this.noti = await this.apiGetSelfNoti()
    if (!this.line) {
      this.loading = false
    }
  },

  methods: {
    async openDialog() {
      this.app_list_loading = true
      this.app_list = await this.apiGetAppService()
      this.app_list_loading = false
      this.app_list_dialog = true
      this.menu = false
    },

    closeDialog() {
      this.app_list_dialog = false
      this.menu = true
    },

    async apiGetAppService() {
      try {
        const res = await this.$store.dispatch('dashboard/getAppService')
        return res.data.data
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiGetSelfNoti() {
      //console.log(localStorage.getItem('endpointChannel').split('/'))
      try {
        const res = await this.$store.dispatch('dashboard/getSelfNoti')
        return res.data.data
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async apiPostSelfNoti(body) {
      try {
        const res = await this.$store.dispatch('dashboard/postSelfNoti', body)
        return res.data.data
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
